export enum BenefitCategoryIds {
    SocialInsurance = 1,
    Benefits = 2,
    Allowances = 3
}